document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('more-in-color-products');
  if (!container) return;

  const productId = container.dataset.productId;
  const productHandle = container.dataset.productHandle;
  const collectionHandles = (container.dataset.collectionHandles || '')
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
  const priorityCollectionHandle = 'bestsellers';
  const maxAdditionalCollectionsToQuery = 3;
  const maxCardsToRender = 10;
  const candidatePoolSize = 30;
  const recommendationsSectionId = 'recommended-products-slider';
  const mobileBreakpoint = 1024;
  const minimumFallbackColors = 7;
  const maximumFallbackColors = 14;
  const colorMapCache = new WeakMap();
  let collectionCardsPool = [];
  let collectionCardsPoolColor = '';
  let activeLoadRequestId = 0;
  let collectionCardsPromise = null;
  let collectionCardsPromiseColor = '';
  let lastRenderedColor = '';
  let resizeRaf = null;
  let lastViewportMode = window.innerWidth <= mobileBreakpoint ? 'mobile' : 'desktop';
  let swiperInitRaf = null;
  const visitSeedCache = new Map();

  function normalizeColor(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/["']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getSimilarColorsDict() {
    try {
      const el = document.getElementById('more-in-color-similar-colors');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  function getExactCandidateColors(selectedColor) {
    const normalized = normalizeColor(selectedColor);
    return normalized ? [normalized] : [];
  }

  function getFallbackCandidateColors(selectedColor) {
    const normalized = normalizeColor(selectedColor);
    if (!normalized) return [];
    const similarColors = getSimilarColorsDict();
    const selectedIsCompound = normalized.includes('-');
    const directCandidates = (similarColors[normalized] || []).map(normalizeColor).filter(Boolean);
    const compoundComponents = selectedIsCompound
      ? getCompoundColorComponents(normalized, similarColors)
      : [];
    const candidates = [];
    const seen = new Set([normalized]);
    const directCompounds = directCandidates.filter((color) => color.includes('-'));
    const directSolids = directCandidates.filter((color) => !color.includes('-'));
    const queue = directCompounds
      .concat(compoundComponents, directSolids)
      .map((color) => ({ color, depth: 1 }));

    while (queue.length && candidates.length < maximumFallbackColors) {
      const { color, depth } = queue.shift();
      if (!color || seen.has(color)) continue;

      seen.add(color);
      candidates.push(color);

      if (candidates.length >= minimumFallbackColors || depth >= 3) continue;

      const nextColors = (similarColors[color] || []).map(normalizeColor).filter(Boolean);
      const orderedNextColors = selectedIsCompound
        ? nextColors.sort((left, right) => Number(right.includes('-')) - Number(left.includes('-')))
        : nextColors;

      orderedNextColors.forEach((nextColor) => {
        if (!seen.has(nextColor)) queue.push({ color: nextColor, depth: depth + 1 });
      });
    }

    return candidates;
  }

  function getCompoundColorComponents(color, similarColors) {
    const knownColors = new Set(Object.keys(similarColors));
    const tokens = color.split('-').filter(Boolean);
    const components = [];

    for (let start = 0; start < tokens.length; start += 1) {
      for (let end = tokens.length; end > start; end -= 1) {
        const component = tokens.slice(start, end).join('-');
        if (component !== color && knownColors.has(component)) {
          components.push(component);
          start = end - 1;
          break;
        }
      }
    }

    return components;
  }

  function getSelectedMainColor() {
    const selected = document.querySelector('.swatch__button.color.selected');
    if (selected?.dataset.color) return selected.dataset.color;

    const colorLabel = document.getElementById('selected-color-label');
    const labelColor = colorLabel?.textContent?.trim() || '';
    if (labelColor) return labelColor;

    return '';
  }

  function getSwatchColorKey(swatch) {
    if (!swatch) return '';
    const colorClass = Array.from(swatch.classList).find((cls) => cls.startsWith('color--'));
    return colorClass ? normalizeColor(colorClass.replace('color--', '')) : '';
  }

  function parseCardColorMap(card) {
    if (!card) return null;
    if (colorMapCache.has(card)) return colorMapCache.get(card);

    const el = card.querySelector('.color-media-map');
    if (!el) {
      colorMapCache.set(card, null);
      return null;
    }

    try {
      const map = JSON.parse(el.textContent);
      colorMapCache.set(card, map);
      return map;
    } catch (e) {
      colorMapCache.set(card, null);
      return null;
    }
  }

  function parseRecommendationMeta(card) {
    const colors = parseCardColorMap(card);
    const hasUnifiedStockData = colors && Object.values(colors).some((color) =>
      Array.isArray(color?.variants)
    );
    if (hasUnifiedStockData) return { colors };

    const legacyMeta = card?.querySelector('.more-in-color-product-meta');
    if (!legacyMeta) return null;

    try {
      return JSON.parse(legacyMeta.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeSize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getSelectedSize() {
    const selectedSizeButton = document.querySelector('.size-option.selected');
    if (selectedSizeButton?.dataset.size) return selectedSizeButton.dataset.size;

    const mobileSizeSelect = document.getElementById('size-select-dropdown');
    if (mobileSizeSelect?.value) return mobileSizeSelect.value;

    return '';
  }

  function getColorMetaForCandidates(card, candidateColors) {
    const meta = parseRecommendationMeta(card);
    if (!meta || !meta.colors) return null;

    for (const colorKey of candidateColors) {
      if (meta.colors[colorKey]) {
        return meta.colors[colorKey];
      }
    }

    return null;
  }

  function getAnyAvailableColorMeta(card) {
    const meta = parseRecommendationMeta(card);
    if (!meta || !meta.colors) return null;

    return Object.values(meta.colors).find((colorMeta) =>
      Array.isArray(colorMeta?.variants) && colorMeta.variants.some((variant) =>
        variant && variant.available !== false
      )
    ) || null;
  }

  function hasAnyAvailableVariant(card) {
    const anyColorMeta = getAnyAvailableColorMeta(card);
    return Boolean(anyColorMeta);
  }

  function getAvailableVariants(colorMeta) {
    if (!colorMeta || !Array.isArray(colorMeta.variants)) return [];
    return colorMeta.variants.filter((variant) => variant && variant.available !== false);
  }

  function getHealthyStockScore(quantity) {
    const parsedQuantity = Number(quantity);
    if (!Number.isFinite(parsedQuantity) || parsedQuantity <= 0) return 0;
    if (parsedQuantity >= 3) return 3;
    if (parsedQuantity === 2) return 2;
    return 1;
  }

  function getColorMetaPriority(colorMeta, selectedSizeKey) {
    if (!colorMeta) {
      return {
        hasAvailable: false,
        selectedSizeAvailable: false,
        selectedSizeStockScore: 0,
        bestStockScore: 0,
        totalAvailableVariants: 0
      };
    }

    const availableVariants = getAvailableVariants(colorMeta);
    const selectedSizeVariant = selectedSizeKey
      ? availableVariants.find((variant) => normalizeSize(variant.size) === selectedSizeKey)
      : null;

    const bestStockScore = availableVariants.reduce((maxScore, variant) => {
      return Math.max(maxScore, getHealthyStockScore(variant.quantity));
    }, 0);

    return {
      hasAvailable: availableVariants.length > 0,
      selectedSizeAvailable: Boolean(selectedSizeVariant),
      selectedSizeStockScore: selectedSizeVariant ? getHealthyStockScore(selectedSizeVariant.quantity) : 0,
      bestStockScore,
      totalAvailableVariants: availableVariants.length
    };
  }

  function getCardSourceRank(card) {
    const parsedRank = Number(card?.dataset.moreInColorSourceRank);
    return Number.isFinite(parsedRank) ? parsedRank : Number.MAX_SAFE_INTEGER;
  }

  function isBestSellerCard(card) {
    return (card?.dataset.moreInColorSource || '') === 'all-best-selling';
  }

  function getVisitSeed(colorValue) {
    const normalizedColor = normalizeColor(colorValue);
    const visitKey = `${productHandle || 'product'}::${normalizedColor}`;
    if (visitSeedCache.has(visitKey)) return visitSeedCache.get(visitKey);

    let visitSeed = 0;
    try {
      const storageKey = `nd-more-in-color-visit:${visitKey}`;
      visitSeed = Number(window.localStorage.getItem(storageKey) || '0') + 1;
      window.localStorage.setItem(storageKey, String(visitSeed));
    } catch (e) {
      visitSeed = 0;
    }

    visitSeedCache.set(visitKey, visitSeed);
    return visitSeed;
  }

  function getVariationRank(card, visitSeed) {
    const handle = getCardHandle(card);
    const input = `${handle}:${visitSeed}`;
    let hash = 0;
    for (let index = 0; index < input.length; index += 1) {
      hash = ((hash << 5) - hash) + input.charCodeAt(index);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function rankCards(cards, options = {}) {
    const {
      selectedSizeKey = '',
      candidateColors = [],
      colorMatchMode = 'none',
      visitSeed = 0
    } = options;

    return cards
      .map((card) => {
        const matchingColorMeta = colorMatchMode === 'none'
          ? getAnyAvailableColorMeta(card)
          : getColorMetaForCandidates(card, candidateColors);
        const priority = getColorMetaPriority(matchingColorMeta, selectedSizeKey);

        return {
          card,
          priority,
          sourceRank: getCardSourceRank(card),
          variationRank: getVariationRank(card, visitSeed)
        };
      })
      .filter((entry) => entry.priority.hasAvailable)
      .sort((left, right) => {
        if (right.priority.selectedSizeAvailable !== left.priority.selectedSizeAvailable) {
          return Number(right.priority.selectedSizeAvailable) - Number(left.priority.selectedSizeAvailable);
        }
        if (right.priority.selectedSizeStockScore !== left.priority.selectedSizeStockScore) {
          return right.priority.selectedSizeStockScore - left.priority.selectedSizeStockScore;
        }
        if (right.priority.bestStockScore !== left.priority.bestStockScore) {
          return right.priority.bestStockScore - left.priority.bestStockScore;
        }
        if (right.priority.totalAvailableVariants !== left.priority.totalAvailableVariants) {
          return right.priority.totalAvailableVariants - left.priority.totalAvailableVariants;
        }
        if (left.sourceRank !== right.sourceRank) {
          return left.sourceRank - right.sourceRank;
        }
        return left.variationRank - right.variationRank;
      })
      .map((entry) => entry.card);
  }

  function pushUniqueCards(targetCards, nextCards) {
    const usedKeys = new Set(targetCards.map(getRecommendationKey).filter(Boolean));
    nextCards.forEach((card) => {
      const recommendationKey = getRecommendationKey(card);
      if (!recommendationKey || usedKeys.has(recommendationKey)) return;
      targetCards.push(card);
      usedKeys.add(recommendationKey);
    });
  }

  function applyVisitVariation(cards, visitSeed) {
    if (!Array.isArray(cards) || cards.length <= 4 || !visitSeed) return cards;

    const fixedCards = cards.slice(0, 3);
    const rotatingCards = cards.slice(3);
    const offset = visitSeed % rotatingCards.length;
    if (!offset) return cards;

    return fixedCards.concat(rotatingCards.slice(offset), rotatingCards.slice(0, offset));
  }

  function ensureDefaultCache(img) {
    if (!img || img.tagName !== 'IMG') return;
    if (!img.dataset.defaultSrc) {
      img.dataset.defaultSrc = img.getAttribute('src') || '';
    }
    if (!img.dataset.defaultSrcset) {
      img.dataset.defaultSrcset = img.getAttribute('srcset') || '';
    }
  }

  function restoreDefault(img) {
    if (!img || img.tagName !== 'IMG') return;
    const ds = img.dataset.defaultSrc || '';
    const dss = img.dataset.defaultSrcset || '';
    if (ds) img.src = ds;
    if (dss) img.setAttribute('srcset', dss);
    else img.removeAttribute('srcset');
    img.style.display = '';
  }

  function ensureImg(node) {
    if (!node) return null;
    if (node.tagName === 'IMG') return node;

    const img = document.createElement('img');
    img.className = node.className;
    img.alt = node.getAttribute('alt') || '';
    img.loading = 'lazy';
    img.decoding = 'async';

    if (node.parentNode) {
      node.parentNode.replaceChild(img, node);
    }

    return img;
  }

  function setImageSource(img, src) {
    if (!img || img.tagName !== 'IMG' || !src) return;
    img.src = src;
    img.setAttribute('srcset', src);
    img.style.display = '';
  }

  function syncCardLinks(card, href) {
    if (!card || !href) return;

    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      if (link.classList.contains('product-swatch')) return;
      link.setAttribute('href', href);
    });
  }

  function applyColorMedia(card, candidateColors) {
    const map = parseCardColorMap(card);
    if (!map) return;

    const img1 = ensureImg(card.querySelector('.product-media--1'));
    const img2 = ensureImg(card.querySelector('.product-media--2'));

    ensureDefaultCache(img1);
    ensureDefaultCache(img2);

    let chosen = null;
    for (const key of candidateColors) {
      if (map[key]) {
        chosen = map[key];
        break;
      }
    }

    if (chosen) {
      setImageSource(img1, chosen.primary);
      if (img2) {
        setImageSource(img2, chosen.hover || chosen.primary);
      }
    } else {
      restoreDefault(img1);
      restoreDefault(img2);
    }
  }

  function initSwiperIn(containerEl) {
    if (!window.Swiper || !containerEl) return;

    containerEl.querySelectorAll('.product-recommendations-swiper').forEach((element) => {
      if (element.swiper) {
        element.swiper.destroy(true, true);
      }

      const swiper = new Swiper(element, {
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        loop: false,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        navigation: {
          prevEl: element.querySelector('.product-upsell-navigation__button--previous'),
          nextEl: element.querySelector('.product-upsell-navigation__button--next'),
        },
      });

      bindSingleSlideWheel(swiper, element);
      swiper.update();
      swiper.slideTo(0, 0, false);
    });
  }

  function bindSingleSlideWheel(swiper, element) {
    let wheelLock = false;
    let wheelUnlockTimer = null;

    function releaseWheelLock(delay) {
      if (wheelUnlockTimer) {
        window.clearTimeout(wheelUnlockTimer);
      }

      wheelUnlockTimer = window.setTimeout(() => {
        wheelLock = false;
        wheelUnlockTimer = null;
      }, delay);
    }

    element.addEventListener('wheel', (event) => {
      const horizontalDelta = event.deltaX;
      const verticalDelta = event.deltaY;
      const isHorizontalIntent =
        Math.abs(horizontalDelta) > Math.abs(verticalDelta) && Math.abs(horizontalDelta) > 18;

      if (!isHorizontalIntent) return;

      const movingNext = horizontalDelta > 0;
      const atReleasedEdge = (movingNext && swiper.isEnd) || (!movingNext && swiper.isBeginning);
      if (atReleasedEdge) return;

      event.preventDefault();
      if (wheelLock || swiper.animating) return;
      wheelLock = true;
      movingNext ? swiper.slideNext() : swiper.slidePrev();
      releaseWheelLock(900);
    }, { passive: false });

    swiper.on('slideChangeTransitionEnd', () => {
      releaseWheelLock(220);
    });
  }

  function scheduleSwiperInit(containerEl) {
    if (!containerEl) return;

    if (swiperInitRaf) {
      window.cancelAnimationFrame(swiperInitRaf);
    }

    swiperInitRaf = window.requestAnimationFrame(() => {
      swiperInitRaf = null;
      initSwiperIn(containerEl);
    });
  }

  function collectCardsFromCollectionPage(doc) {
    if (!doc) return [];
    const candidates = Array.from(doc.querySelectorAll('.product-card--item.swiper-slide, .product-grid-item, .product-card'));

    return candidates
      .map((node) => {
        if (node.classList.contains('product-card')) return node;
        return node.querySelector('.product-card') || node;
      })
      .filter(Boolean);
  }

  function annotateCards(cards, sourceLabel, startingRank = 0) {
    return cards.map((card, index) => {
      card.dataset.moreInColorSource = sourceLabel;
      card.dataset.moreInColorSourceRank = String(startingRank + index);
      return card;
    });
  }

  function renderCards(cards) {
    if (!cards.length) {
      container.innerHTML = '';
      return;
    }

    const navigationTemplate = document.getElementById('product-upsell-navigation-template');
    const navigationHtml = navigationTemplate?.innerHTML || '';
    const html = `
      <div class="swiper product-recommendations-swiper">
        <div class="swiper-wrapper">
          ${cards
            .map((card) => `<div class="product-card--item swiper-slide">${card.outerHTML}</div>`)
            .join('')}
        </div>
        ${navigationHtml}
      </div>
    `;

    container.innerHTML = html;
    scheduleSwiperInit(container);
  }

  function cardMatchesColor(card, colorValue, matchMode = 'exact') {
    const candidates = matchMode === 'fallback'
      ? getFallbackCandidateColors(colorValue)
      : getExactCandidateColors(colorValue);
    const candidateSet = new Set(candidates);
    if (!candidateSet.size) return true;
    const swatches = Array.from(card.querySelectorAll('.product-swatches-wrapper .product-swatch'));
    return swatches.some((swatch) => candidateSet.has(getSwatchColorKey(swatch)));
  }

  function renderFromCollectionPool(colorValue) {
    if (!collectionCardsPool.length) return false;

    const selectedSizeKey = normalizeSize(getSelectedSize());
    const exactCandidateColors = getExactCandidateColors(colorValue);
    const fallbackCandidateColors = getFallbackCandidateColors(colorValue);
    const visitSeed = getVisitSeed(colorValue);

    const exactMatches = collectionCardsPool.filter((card) => cardMatchesColor(card, colorValue, 'exact'));
    const fallbackMatches = collectionCardsPool.filter((card) =>
      !cardMatchesColor(card, colorValue, 'exact') && cardMatchesColor(card, colorValue, 'fallback')
    );

    const bestSellerExactMatches = applyVisitVariation(rankCards(
      exactMatches.filter((card) => isBestSellerCard(card)),
      { selectedSizeKey, candidateColors: exactCandidateColors, colorMatchMode: 'color', visitSeed }
    ), visitSeed);

    const broaderExactMatches = applyVisitVariation(rankCards(
      exactMatches.filter((card) => !isBestSellerCard(card)),
      { selectedSizeKey, candidateColors: exactCandidateColors, colorMatchMode: 'color', visitSeed }
    ), visitSeed);

    const candidateCards = [];
    pushUniqueCards(candidateCards, bestSellerExactMatches.slice(0, candidatePoolSize));
    pushUniqueCards(candidateCards, broaderExactMatches.slice(0, candidatePoolSize));

    const fallbackCardGroups = fallbackCandidateColors.map((fallbackColor) => {
      const matchesForColor = fallbackMatches.filter((card) =>
        cardMatchesColor(card, fallbackColor, 'exact')
      );
      const bestSellerMatches = applyVisitVariation(rankCards(
        matchesForColor.filter((card) => isBestSellerCard(card)),
        { selectedSizeKey, candidateColors: [fallbackColor], colorMatchMode: 'color', visitSeed }
      ), visitSeed);
      const broaderMatches = applyVisitVariation(rankCards(
        matchesForColor.filter((card) => !isBestSellerCard(card)),
        { selectedSizeKey, candidateColors: [fallbackColor], colorMatchMode: 'color', visitSeed }
      ), visitSeed);

      return bestSellerMatches.concat(broaderMatches);
    }).filter((cards) => cards.length);

    fallbackCardGroups.forEach((cards) => {
      if (candidateCards.length >= maxCardsToRender) return;
      pushUniqueCards(candidateCards, cards.slice(0, 1));
    });

    fallbackCardGroups.forEach((cards) => {
      if (candidateCards.length >= maxCardsToRender) return;
      pushUniqueCards(candidateCards, cards.slice(0, candidatePoolSize));
    });

    const cardsToRender = candidateCards.slice(0, maxCardsToRender);

    renderCards(cardsToRender);
    applyColorToCards(colorValue, { allowFallback: true });
    return cardsToRender.length > 0;
  }

  function getCardHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    const href = link.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getCardTitle(card) {
    return (card?.querySelector('.product-title')?.textContent || '')
      .trim()
      .toLowerCase();
  }

  function getRecommendationKey(card) {
    return getCardTitle(card) || getCardHandle(card);
  }

  async function loadCollectionCards(colorValue = getSelectedMainColor()) {
    const requestId = ++activeLoadRequestId;
    const normalizedColor = normalizeColor(colorValue);
    const handlesToQuery = [
      priorityCollectionHandle,
      ...collectionHandles.filter((handle) => handle !== priorityCollectionHandle),
    ].slice(0, maxAdditionalCollectionsToQuery + 1);

    const exactColorFilter = colorValue ? `&filter.v.option.colour=${encodeURIComponent(colorValue)}` : '';
    const allCollectionUrl = `/collections/all?sort_by=best-selling${exactColorFilter}`;

    let allCollectionCards = [];
    try {
      const res = await fetch(allCollectionUrl);
      if (res.ok) {
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        allCollectionCards = annotateCards(collectCardsFromCollectionPage(doc), 'all-best-selling');
      }
    } catch (e) {
      allCollectionCards = [];
    }

    let supplementalCards = [];
    if (handlesToQuery.length) {
      const fetched = await Promise.all(
        handlesToQuery.map(async (handle) => {
          try {
            const res = await fetch(`/collections/${handle}?view=ajax&limit=40`);
            if (!res.ok) return [];
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cards = annotateCards(collectCardsFromCollectionPage(doc), `supplemental:${handle}`, allCollectionCards.length);
            return cards;
          } catch (e) {
            return [];
          }
        })
      );

      supplementalCards = fetched.flat();
    }

    if (requestId !== activeLoadRequestId) return false;

    let cards = allCollectionCards.concat(supplementalCards);

    const seen = new Set();
    cards = cards.filter((card) => {
      const handle = getCardHandle(card);
      if (!handle || seen.has(handle)) return false;
      seen.add(handle);
      return true;
    });

    if (productHandle) {
      cards = cards.filter((card) => getCardHandle(card) !== productHandle);
    }

    if (requestId !== activeLoadRequestId) return false;

    collectionCardsPool = cards;
    collectionCardsPoolColor = normalizedColor;
    return cards.length > 0;
  }

  async function ensureCollectionCards(colorValue) {
    const normalizedColor = normalizeColor(colorValue);
    if (collectionCardsPool.length && collectionCardsPoolColor === normalizedColor) return true;

    if (!collectionCardsPromise || collectionCardsPromiseColor !== normalizedColor) {
      collectionCardsPromiseColor = normalizedColor;
      collectionCardsPromise = loadCollectionCards(colorValue);
    }

    const pendingCollectionCards = collectionCardsPromise;
    try {
      return await pendingCollectionCards;
    } finally {
      if (collectionCardsPromise === pendingCollectionCards) {
        collectionCardsPromise = null;
        collectionCardsPromiseColor = '';
      }
    }
  }

  async function reloadForColor(color) {
    const nextColor = color || getSelectedMainColor();
    const normalizedNextColor = normalizeColor(nextColor);

    if (normalizedNextColor && normalizedNextColor === lastRenderedColor && collectionCardsPool.length) {
      applyColorToCards(nextColor, { allowFallback: true });
      return;
    }

    const loaded = await ensureCollectionCards(nextColor);
    if (!loaded) {
      applyColorToCards(nextColor, { allowFallback: true });
      return;
    }

    const rendered = renderFromCollectionPool(nextColor);

    if (!rendered) {
      applyColorToCards(nextColor, { allowFallback: true });
    }

    lastRenderedColor = normalizedNextColor;
  }

  function updateSwatchVisibility(productCard) {
    const swatchWrapper = productCard.querySelector('.product-swatches-wrapper');
    const swatches = swatchWrapper ? Array.from(swatchWrapper.querySelectorAll('.product-swatch')) : [];
    const plusIcon = productCard.querySelector('.swatch-plus');

    if (!swatchWrapper || !swatches.length) return;

    swatches.forEach((swatch) => swatch.classList.remove('swatch--hidden'));

    const isMobile = window.innerWidth < 1024;
    const limit = isMobile ? 5 : 7;

    if (swatches.length > limit) {
      swatches.forEach((swatch, index) => {
        if (index >= limit) {
          swatch.classList.add('swatch--hidden');
        }
      });
      plusIcon?.classList.add('visible');
    } else {
      plusIcon?.remove();
    }
  }

  function setCardVisibility(card, isVisible) {
    const slide = card.closest('.swiper-slide') || card.parentElement;
    if (!slide) return;
    slide.style.display = isVisible ? '' : 'none';
  }

  function applyColorToCards(colorValue, options = {}) {
    const allowFallback = Boolean(options.allowFallback);
    const exactCandidates = getExactCandidateColors(colorValue);
    const fallbackCandidates = allowFallback ? getFallbackCandidateColors(colorValue) : [];
    const candidateColors = exactCandidates.concat(fallbackCandidates);
    if (!candidateColors.length) return;

    const cards = container.querySelectorAll('.product-card');
    const matchResults = [];

    cards.forEach((card) => {
      const swatches = Array.from(card.querySelectorAll('.product-swatches-wrapper .product-swatch'));
      const matchingSwatch = candidateColors.reduce((match, candidateColor) => {
        return match || swatches.find((swatch) => getSwatchColorKey(swatch) === candidateColor);
      }, null);
      matchResults.push({ card, swatches, matchingSwatch, hasMatch: Boolean(matchingSwatch) });
    });

    matchResults.forEach(({ card, swatches, matchingSwatch, hasMatch }) => {
      const swatchWrapper = card.querySelector('.product-swatches-wrapper');
      if (!swatchWrapper || !swatches.length) {
        setCardVisibility(card, false);
        return;
      }

      setCardVisibility(card, hasMatch);
      if (!hasMatch) return;

      swatches.forEach((swatch) => swatch.classList.remove('selected--swatch'));

      if (matchingSwatch) {
        matchingSwatch.classList.add('selected--swatch');
        swatchWrapper.prepend(matchingSwatch);

        const swatchHref = matchingSwatch.getAttribute('href');
        if (swatchHref) {
          syncCardLinks(card, swatchHref);
        }
      } else {
        swatches[0].classList.add('selected--swatch');
      }

      applyColorMedia(card, candidateColors);
      updateSwatchVisibility(card);
    });

    const swiperEl = container.querySelector('.product-recommendations-swiper');
    swiperEl?.swiper?.update();
  }

  function renderMoreInThisColor() {
    const selectedColor = getSelectedMainColor();
    reloadForColor(selectedColor);
  }

  function refreshRenderedCardsForViewport() {
    const cards = Array.from(container.querySelectorAll('.product-card'));
    if (!cards.length) return;

    cards.forEach((card) => updateSwatchVisibility(card));
    container.querySelector('.product-recommendations-swiper')?.swiper?.update();
  }

  function handleViewportResize() {
    const nextViewportMode = window.innerWidth <= mobileBreakpoint ? 'mobile' : 'desktop';
    if (nextViewportMode === lastViewportMode) return;

    lastViewportMode = nextViewportMode;
    refreshRenderedCardsForViewport();
  }

  function bindColorChangeListeners() {
    document.addEventListener('pdp:color-changed', function (event) {
      const color = event.detail?.color || '';
      reloadForColor(color);
    });

    window.addEventListener('resize', function () {
      if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
      resizeRaf = window.requestAnimationFrame(() => {
        resizeRaf = null;
        handleViewportResize();
      });
    });
  }

  function loadMoreInColorRecommendationsFallback() {
    if (!productId) return;

    const fallbackRequestId = activeLoadRequestId;

    fetch(`/recommendations/products?section_id=${recommendationsSectionId}&product_id=${productId}&limit=10`)
      .then((res) => res.text())
      .then((html) => {
        if (fallbackRequestId !== activeLoadRequestId) return;
        container.innerHTML = html;
        scheduleSwiperInit(container);
        renderMoreInThisColor();
      });
  }

  async function loadMoreInColorProducts() {
    try {
      const loadedFromCollection = await ensureCollectionCards(getSelectedMainColor());

      if (!loadedFromCollection) {
        loadMoreInColorRecommendationsFallback();
        return;
      }

      renderMoreInThisColor();
    } catch (e) {
      loadMoreInColorRecommendationsFallback();
    }
  }

  bindColorChangeListeners();
  loadMoreInColorProducts();
});
